import { render, staticRenderFns } from "./EmployeeBaseField.vue?vue&type=template&id=10dc7dd6"
import script from "./EmployeeBaseField.vue?vue&type=script&lang=js"
export * from "./EmployeeBaseField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports